import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { Notification } from './notification';

@Injectable()
export class NotificationsService {

    getNotifications(): Observable<Notification[]> {
        return of([]);
    }

    markAsRead(notifications: Notification[]): void {
    }

    close(notification: Notification) {
    }
}